var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 6.74988C16.9143 6.74991 17.2501 7.08574 17.2502 7.49988V19.1893L20.4699 15.9696C20.7628 15.6768 21.2376 15.6768 21.5304 15.9696C21.8233 16.2625 21.8232 16.7373 21.5304 17.0302L17.0304 21.5302C16.8898 21.6708 16.6991 21.7499 16.5002 21.7499C16.3013 21.7499 16.1106 21.6708 15.9699 21.5302L11.4699 17.0302L11.4181 16.9735C11.1779 16.6789 11.1953 16.2442 11.4699 15.9696C11.7445 15.6951 12.1793 15.6776 12.4738 15.9178L12.5304 15.9696L15.7502 19.1893V7.49988C15.7502 7.08572 16.086 6.74988 16.5002 6.74988Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02654 2.41785C7.32111 2.17763 7.75587 2.19506 8.03045 2.46961L12.5304 6.96961L12.5822 7.02625C12.8225 7.3208 12.805 7.75554 12.5304 8.03015C12.2558 8.30476 11.8211 8.32222 11.5265 8.08191L11.4699 8.03015L8.25017 4.81043V16.4999C8.25017 16.9141 7.91436 17.2498 7.50017 17.2499C7.08596 17.2499 6.75017 16.9141 6.75017 16.4999V4.81043L3.53045 8.03015C3.23755 8.32305 2.76279 8.32305 2.4699 8.03015C2.17704 7.73726 2.17702 7.26249 2.4699 6.96961L6.9699 2.46961L7.02654 2.41785Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsUpDown);
export default __webpack_public_path__ + "static/media/arrows-up-down.d3c75649ab9bbf0e6d9f1774921109b8.svg";
export { ForwardRef as ReactComponent };